export default __webpack_public_path__ + "be9daf06aa1b3ebbcfb16e9564ea2136.svg";